function ltrim(str) {
  if (!str) return str;
  return str.replace(/^\s+/g, '');
}

function rtrim(str) {
  if (!str) return str;
  return str.replace(/\s+$/g, ' ');
}

function trimFc(formik) {
  return (e) => {
    const ff = ltrim(rtrim(e.target.value));
    // Fall back to id if name is missing — MUI TextField only forwards
    // name onto e.target if explicitly set, so a name-less TextField with
    // an id would otherwise call setFieldValue('', …) and silently lose
    // the keystroke.
    const fieldKey = e.target.name || e.target.id;
    if (!fieldKey) return;
    formik.setFieldValue(fieldKey, ff);
  };
}

export default trimFc;
